// @core/api/endpoints/affiliate/update_campaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CampaignResponse,
  UpdateCampaignRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Update campaign
 * Updates an existing campaign with the provided data. Returns the updated resource.
 */
export async function UpdateCampaign(
  campaign_id: string,
  data: UpdateCampaignRequest,
  options?: RequestOptions
): Promise<CampaignResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/campaigns/:campaign_id`;
  requestPath = requestPath.replace(':campaign_id', encodeURIComponent(campaign_id));
  const requestOptions = options;
  return client.patch<CampaignResponse>(requestPath, data, requestOptions);
}
